/* Love, Amma theme runtime: component shim, Shopify cart bridge, header jar. */
(function () {
  'use strict';

  class DCLogic {
    constructor(props) {
      this.props = props || {};
      this.state = {};
      this.__scope = null;
    }
    setState(patch) {
      const prev = Object.assign({}, this.state);
      Object.assign(this.state, typeof patch === 'function' ? patch(this.state, this.props) : patch);
      this.__render();
      if (this.componentDidUpdate) this.componentDidUpdate(this.props, prev);
    }
    forceUpdate() {
      this.__render();
    }
    __render() {
      if (this.__scope) Object.assign(this.__scope, this.renderVals());
    }
  }
  window.DCLogic = DCLogic;

  const vmap = {};
  let cart = {};
  let bumpN = 0;

  function keyOf(it) {
    return it.handle + '|' + (it.variant_title || 'Default Title');
  }

  function fromShopify(c) {
    const m = {};
    (c.items || []).forEach(function (it) {
      const k = keyOf(it);
      const cur = m[k];
      m[k] = {
        q: (cur ? cur.q : 0) + it.quantity,
        p: it.final_price / 100,
        n: it.product_title + (it.variant_title ? ' (' + it.variant_title + ')' : ''),
        img: it.image,
        vid: it.variant_id
      };
      vmap[k] = it.variant_id;
    });
    return m;
  }

  // The page carries the cart it was rendered with, so components start from the same jar as the server copy.
  try {
    if (window.LA_CART) cart = fromShopify(window.LA_CART);
  } catch (e) {}

  function totals() {
    let count = 0;
    let total = 0;
    Object.keys(cart).forEach(function (k) {
      count += cart[k].q;
      total += cart[k].q * cart[k].p;
    });
    return { count: count, total: total };
  }

  function paintPill(bump) {
    const t = totals();
    document.querySelectorAll('[data-la-count]').forEach(function (el) {
      el.textContent = t.count;
    });
    const pill = document.getElementById('la-jar');
    if (!pill) return;
    pill.setAttribute('aria-label', 'Cart, ' + t.count + (t.count === 1 ? ' item' : ' items'));
    if (bump) {
      bumpN += 1;
      pill.classList.remove('la-bump-a', 'la-bump-b');
      void pill.offsetWidth;
      pill.classList.add(bumpN % 2 ? 'la-bump-a' : 'la-bump-b');
    }
  }

  function broadcast(bump) {
    paintPill(bump);
    try {
      window.dispatchEvent(new CustomEvent('la-cart', { detail: { cart: Object.assign({}, cart), from: 'shopify' } }));
    } catch (e) {}
  }

  function refresh(bump) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        cart = fromShopify(c);
        broadcast(bump);
        return c;
      })
      .catch(function () {});
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  let chain = Promise.resolve();

  // A component hands over the jar it wants; the difference is sent to Shopify, then every component gets the real cart back.
  function sync(next) {
    chain = chain.then(function () {
      const keys = {};
      Object.keys(cart).forEach(function (k) { keys[k] = 1; });
      Object.keys(next || {}).forEach(function (k) { keys[k] = 1; });
      const adds = [];
      const changes = [];
      let grew = false;
      Object.keys(keys).forEach(function (k) {
        const a = cart[k] ? cart[k].q : 0;
        const b = next && next[k] ? next[k].q : 0;
        if (a === b) return;
        const vid = vmap[k];
        if (!vid) return;
        if (b > a) grew = true;
        if (a === 0) adds.push({ id: vid, quantity: b });
        else changes.push({ id: String(vid), quantity: b });
      });
      let p = Promise.resolve();
      if (adds.length) p = p.then(function () { return post('/cart/add.js', { items: adds }); });
      changes.forEach(function (ch) {
        p = p.then(function () { return post('/cart/change.js', ch); });
      });
      return p.catch(function () {}).then(function () { return refresh(grew); });
    });
    return chain;
  }

  window.LA = {
    register: function (key, vid) {
      if (key && vid) vmap[key] = vid;
    },
    sync: sync,
    refresh: refresh,
    // Star ratings come from the review metafields TrustShop keeps on each product.
    rating: function (handle, r, c) {
      if (r && Number(c) > 0) return [Number(r), Number(c)];
      return null;
    },
    get cart() {
      return Object.assign({}, cart);
    }
  };

  // Copies the time of running CSS animations (marquees, floats) from the server copy to the component,
  // so nothing jumps back to its start when the component takes over.
  function animTimes(root) {
    const out = {};
    try {
      if (!root.getAnimations) return out;
      root.getAnimations({ subtree: true }).forEach(function (a) {
        if (!a.animationName || a.timeline !== document.timeline) return;
        const k = a.animationName;
        (out[k] = out[k] || []).push(a.currentTime);
      });
    } catch (e) {}
    return out;
  }

  function applyTimes(root, times) {
    try {
      if (!root.getAnimations) return;
      const seen = {};
      root.getAnimations({ subtree: true }).forEach(function (a) {
        if (!a.animationName || a.timeline !== document.timeline) return;
        const k = a.animationName;
        const i = seen[k] = (seen[k] || 0) + 1;
        const t = times[k] && times[k][i - 1];
        if (t !== undefined && t !== null) a.currentTime = t;
      });
    } catch (e) {}
  }

  function swap(live, ssr) {
    // Images the server copy has already loaded are decoded in the component before it is shown.
    const done = {};
    Array.prototype.forEach.call(ssr.querySelectorAll('img'), function (i) {
      if (i.complete && i.naturalWidth) done[i.currentSrc || i.src] = 1;
    });
    const imgs = Array.prototype.slice.call(live.querySelectorAll('img')).filter(function (i) {
      return done[i.src] && !i.hasAttribute('data-la-keep');
    }).slice(0, 12);
    const ready = Promise.all(imgs.map(function (i) {
      return i.decode ? i.decode().catch(function () {}) : Promise.resolve();
    }));
    Promise.race([ready, new Promise(function (r) { setTimeout(r, 400); })]).then(function () {
      // The largest images and headings move across as they are, so they are not painted a second time.
      const ks = ssr.querySelectorAll('[data-la-keep]');
      const kl = live.querySelectorAll('[data-la-keep]');
      if (ks.length === kl.length) {
        Array.prototype.forEach.call(kl, function (el, i) {
          if (ks[i].tagName === el.tagName && el.parentNode) el.parentNode.replaceChild(ks[i], el);
        });
      }
      const times = animTimes(ssr);
      ssr.remove();
      live.hidden = false;
      applyTimes(live, times);
    });
  }

  // Mounts a component on one or more hosts. Each host holds the component template and, for the
  // first render, a server-rendered copy that stays on screen until the component is ready.
  window.laMount = function (C, sels) {
    C.prototype.loadCart = function () {
      return window.LA.cart;
    };
    C.prototype.saveCart = function (c) {
      window.LA.sync(c);
    };
    const comp = new C({ motion: true });
    const scope = window.PetiteVue.reactive(comp.renderVals());
    comp.__scope = scope;
    const swaps = [];
    (Array.isArray(sels) ? sels : [sels]).forEach(function (sel) {
      const host = document.querySelector(sel);
      if (!host) return;
      const tpl = host.querySelector('template[data-la-tpl]');
      if (!tpl) return;
      const ssr = host.querySelector('[data-la-ssr]');
      const live = document.createElement('div');
      live.className = 'la-live';
      live.appendChild(tpl.content.cloneNode(true));
      if (ssr) {
        live.hidden = true;
        host.insertBefore(live, ssr);
        swaps.push([live, ssr]);
      } else {
        host.appendChild(live);
      }
      window.PetiteVue.createApp(scope).mount(live);
    });
    if (comp.componentDidMount) comp.componentDidMount();
    swaps.forEach(function (s) { swap(s[0], s[1]); });
    return comp;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { refresh(false); });
  } else {
    refresh(false);
  }
})();
